/* ---------------------------------------------------------------------------
 *  Camera‑entry API helper  (exactly parallels src/api/voiceEntry.ts)
 * ------------------------------------------------------------------------- */

import { APINodeClient } from "./apiNodeCore";

const api = new APINodeClient();

/**
 * Upload an image (photo) captured from camera or file‑picker.
 * @param file      The photo file (jpeg / png / etc.)
 * @param fileType  Logical type in backend, e.g. "Booking Entry"
 */
export const submitImageEntryApi = async ({
  file,
  fileType,
}: {
  file: File;
  fileType: string;
}) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("fileType", fileType);  // same field backend expects
  formData.append("fileName", "fileName"); // keep parity with audio

  /* Re‑use a generic "createWithFile" helper or make a new one           */
  /* If your APINodeClient already has createWithFileForAudio,            */
  /* either 1) rename it generically or 2) duplicate with image suffix.   */
  return api.createWithFileForAudio("/api/photo/submit", formData);
  //           ^^^^^^^^^^^^^^^^^^^^^  if you prefer, add
  //           createWithFileForImage and call it here.
};
